class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      const { billing, ...rest } = filter
      return {
        billing: {
          billing_status: ['to_check', 'to_validate'],
          ...billing
        },
        ...rest
      }
    }
  }
}

export default Callbacks
